/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SwatchSelectorMinimal_item = {
    readonly isMultiSku: boolean;
    readonly variableAttributes: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly variableAttributeData: {
            readonly swatchSort: ReadonlyArray<{
                readonly swatch: {
                    readonly serviceId: string | null;
                    readonly displayName: string | null;
                    readonly imageUrl: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "SwatchSelectorMinimal_item";
};
export type SwatchSelectorMinimal_item$data = SwatchSelectorMinimal_item;
export type SwatchSelectorMinimal_item$key = {
    readonly " $data"?: SwatchSelectorMinimal_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelectorMinimal_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwatchSelectorMinimal_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttribute",
      "kind": "LinkedField",
      "name": "variableAttributes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VariableAttributeSortType",
          "kind": "LinkedField",
          "name": "variableAttributeData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SwatchSort",
              "kind": "LinkedField",
              "name": "swatchSort",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Swatch",
                  "kind": "LinkedField",
                  "name": "swatch",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imageUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'afbae8226322c466b45a405b5aa8d2e4';
export default node;
